import script from "./MoleculeCardAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeCardAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeCardAccordion.vue?vue&type=style&index=0&id=156f2d28&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156f2d28"]])

export default __exports__